type Entry<T> = {
    [K in keyof T]: [K, T[K]]
}[keyof T];

export function filterObject<T extends object>(obj: T, fn: (entry: Entry<T>, i: number, arr: Entry<T>[]) => boolean)
{
    return Object.fromEntries(
        (Object.entries(obj) as Entry<T>[]).filter(fn)
    )as Partial<T>;
}

export function toString<T extends object>(object: T) {
    return Object.entries(object)
        .filter(([_, value]) => value != '')
        .map(([key, value]): string => `${key}: ${value}`)
        .join(';\n ');
}

export interface IStringIndex extends Record<string, any> {}
